import * as yup from 'yup';

export const createTechnicalSupportProviderDialogSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  contactId: yup.string().nullable().default(null).required().label('Contact Id')
});
